import { useEffect, useState } from 'react';

import useAiAssistantStore from '../stores/useAiAssistantStore';
import type { TAiAssistantSurface, TAiAssistantOrigin } from '../types';

const useShouldAnimateAiAssistantRun = (
  runId: string,
  surface: TAiAssistantSurface,
  origin: TAiAssistantOrigin | undefined
): boolean => {
  const { read, update } = useAiAssistantStore();
  // Capture once at mount; deriving on each render would stop an active typing reveal after the store update.
  const [shouldAnimate] = useState(() => read(surface, origin).animatedRunId !== runId);

  // Mount-only: consumers key instances by runId and keep their assistant scope stable for that instance.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (shouldAnimate) update(surface, origin, { animatedRunId: runId });
  }, []);

  return shouldAnimate;
};

export default useShouldAnimateAiAssistantRun;
